export default  {
    component: 'plant_ws_map',
    name: 'plant_ws_map',
    fields: [
      {
        param: 'plant_id',
        type: 'number',
        required: true,
        identifier: true,
        hidden: true
      },
      {
        name: 'Temperature (Ref. block Id)',
        param: 'temp_ref_device_id',
        type: 'number',
        description: `**Condition 1** : If plant has ambient temp add the block ID to which it needs to refer e.g "1"
        **Condition 2** : If plant does not have ambient temp do not add anything it will refer to 3rd API`
      },
      {
        name: 'Temperature (Ref. device Id)',
        param: 'temp_ref_block_id',
        type: 'number',
        description: `**Condition 1** : If plant has ambient temp add the ws ID to which it needs to refer e.g "1"
        **Condition 2** : If plant does not have ambient temp do not add anything it will refer to 3rd API`
      },
      {
        name: 'Irradiance (Ref. block Id)',
        param: 'irr_ref_block_id',
        type: 'number',
        description: `**Condition 1** : If plant has PoA add the block ID to which it needs to refer e.g "1"
        **Condition 2** : If plant does not have PoA do not add anything`
      },
      {
        name: 'Irradiance (Ref. device Id)',
        param: 'irr_ref_device_id',
        type: 'number',
        description: `**Condition 1** : If plant has PoA add the ws ID to which it needs to refer e.g "1"
        **Condition 2** : If plant does not have PoA do not add anything`
      },
      {
        name: 'GHI (Ref. block Id)',
        param: 'ghi_irr_ref_block_id',
        type: 'number',
        description: `**Condition 1** : If plant has GHI add the block ID to which it needs to refer e.g "1"
        **Condition 2** : If plant does not have GHI do not add anything`
      },
      {
        name: 'GHI (Ref. device Id)',
        param: 'ghi_irr_ref_device_id',
        type: 'number',
        description: `**Condition 1** : If plant has GHI add the ws ID to which it needs to refer e.g "1"
        **Condition 2** : If plant does not have GHI do not add anything`
      },
      {
        name: 'Wind (Ref. device Id)',
        param: 'wind_ref_block_id',
        type: 'number',
        description: `**Condition 1** : If plant has wind speed param add the ws ID to which it needs to refer e.g "1"
        **Condition 2** : If plant does not have wind do not add anything`
      },
      {
        name: 'Wind (Ref. block Id)',
        param: 'wind_ref_device_id',
        type: 'number',
        description: `**Condition 1** : If plant has wind speed param add the block ID to which it needs to refer e.g "1"
        **Condition 2** : If plant does not have wind do not add anything`
      },
      {
        name: 'WS Type',
        param: 'ws_type',
        type: 'text',
        description: `Their are 2 options:
        - discrete (Seperate graphs will be plotted)
        - cluster (few graphs will be merged. e.g. both irradiance graph/ both temp graph)`
      },
      {
        name: 'PR Type',
        param: 'pr_type',
        type: 'text',
        description: `3 Options available
        - POA
        - GHI
        - RAD`
      },
      {
        name: 'Rad (Ref. block Id)',
        param: 'rad_device_ref_id',
        type: 'number',
        description: `**Condition 1** : If plant has wind speed param add the block ID to which it needs to refer e.g "1"
        **Condition 2** : If plant does not have wind do not add anything`
      },
      {
        name: 'Rad Ref ID',
        param: 'rad_ref_id',
        type: 'number',
        description: `**Condition 1** : If plant has wind speed param add the ws ID to which it needs to refer e.g "1"
        **Condition 2** : If plant does not have wind do not add anything`
      },
      {
        name: 'PoA Primary Refid',
        param: 'poa_primary_refid',
        type: 'text',
      },
      {
        name: 'PoA secondary Refid',
        param: 'poa_secondar_refid',
        type: 'number',
      },
      {
        name: 'Calculation Type',
        param: 'calculation_type',
        type: 'text',
      }
    ]
  }
        
